import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const CloudUpload = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M12 19.25v-7.5m0 0 2.5 2.5m-2.5-2.5-2.5 2.5m5.5 5h3.125a4.125 4.125 0 1 0-.13-8.248q.005-.126.005-.252A6 6 0 0 0 6.326 8.793 5.251 5.251 0 0 0 7 19.25h2'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M5.78 8.124a6.751 6.751 0 0 1 12.954 2.164A4.876 4.876 0 0 1 18.125 20H12.75v-6.44l1.22 1.22a.75.75 0 1 0 1.06-1.06l-2.5-2.5a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 1 0 1.06 1.06l1.22-1.22V20H7A6 6 0 0 1 5.78 8.124'
        fill='currentColor'
      />
    )}
  </IconBase>
);
